export interface IUpdateProfileRequest {
  language: string;
  unitOfMeasurement: number;
  bodyUnitSystem?: number;
  dataRegion?: string;
}

/**
 * MVP-72 — simplified snapshot of the user's current Phase assignment. Mirrors
 * the SU `ICurrentPhaseInfo` shape. `id`, `name`, and `durationDays` were
 * removed when the Phase table was replaced by a `UserPhase` enum column.
 */
export interface ICurrentPhaseInfo {
  phase: string;
  startedAt: string | null;
  expiresAt: string | null;
  daysRemaining: number;
  isExpired: boolean;
}

/**
 * Test-phase metadata returned on `GET /api/users/me` and `GET /api/users/profile` (MVP-8).
 * Null when the user has no active phase (deactivated / production).
 */
export interface ITestPhase {
  startAt: string;
  endAt: string;
  daysRemaining: number;
  status: 'Active' | 'Expired' | 'Cancelled';
}

export interface IUserProfile extends IUpdateProfileRequest {
  labProvider?: string;
  populationRisk?: string;
  email: string;
  userId: string;
  medicalSpecialty: string;
  userRole?: number;
  dataRegion?: string;
  hasPassword?: boolean;
  isSuperUser?: boolean;
  testPhase?: ITestPhase | null;
  fullName?: string | null;
  companyName?: string | null;
  departmentName?: string | null;
  billingStreet?: string | null;
  billingZip?: string | null;
  billingCity?: string | null;
  billingCountryId?: number | null;
  invoicingEmail?: string | null;
  currentPhase?: ICurrentPhaseInfo;
  hasApiAccess?: boolean;
}
